import { z } from 'zod';
// plaid item response schema
export const plaidItemResponseSchema = z.object({
    id: z.string().uuid(),
    itemId: z.string(),
    institutionId: z.string().nullable(),
    institutionName: z.string().nullable(),
    txCursorLastSynced: z.string().nullable().optional(),
    errorCode: z.string().nullable().optional(),
    errorMessage: z.string().nullable().optional(),
    timeCreated: z.string(),
});
